import React, { PropsWithChildren, useState } from 'react';
import * as Collapsible from '@radix-ui/react-collapsible';
import { ChevronDownIcon } from '@radix-ui/react-icons';
import { IconButton } from '@producer/ui-kit';

import styles from './collapsible-item.module.scss';
type CollapsibleItemProps = {
  title?: React.ReactNode | string;
  actions?: React.ReactNode;
  defaultOpen?: boolean;
  isTransparent?: boolean;
  triggerType?: 'default-small' | 'default-medium' | 'transparent-small';
  titleAlignment?: 'start' | 'center';
  padding?: 'default' | 'none';
  onCollapseChange?: (isOpen?: boolean) => void;
};

export const CollapsibleItem: React.FC<PropsWithChildren<CollapsibleItemProps>> = ({
  title,
  actions,
  defaultOpen,
  isTransparent,
  triggerType = 'default-medium',
  titleAlignment = 'start',
  padding = 'default',
  onCollapseChange,
  children,
}) => {
  const [open, setOpen] = useState(defaultOpen);
  const [triggerVersion, triggerSize] = triggerType.split('-');

  const handleOpenChange = (isOpen?: boolean) => {
    setOpen(isOpen);
    onCollapseChange?.(isOpen);
  };

  return (
    <Collapsible.Root open={open} onOpenChange={handleOpenChange}>
      <Collapsible.Trigger className={styles['trigger']} id="collapsible-trigger" asChild>
        <div
          className={styles['header']}
          data-transparent={isTransparent}
          data-align={titleAlignment}
          data-padding={padding}
        >
          {title && <div className={styles['title']}>{title}</div>}

          <div className={styles['right-container']}>
            {actions}

            {triggerVersion === 'default' ? (
              <IconButton icon={<ChevronDownIcon className="trigger-chevron" />} />
            ) : (
              <ChevronDownIcon className="trigger-chevron" color="var(--color-grayscale-manatee)" />
            )}
          </div>
        </div>
      </Collapsible.Trigger>

      <Collapsible.Content className={styles['content']} id="collapsible-content">
        {children}
      </Collapsible.Content>
    </Collapsible.Root>
  );
};
